import { createFileRoute } from '@tanstack/react-router';

interface RoleAddSearch {
  id?: string;
  cloneId?: string;
}

export const Route = createFileRoute('/t/roles/add')({
  staticData: { hideShell: true },
  validateSearch: (search: Record<string, unknown>): RoleAddSearch => ({
    id: typeof search.id === 'string' ? search.id : undefined,
    cloneId: typeof search.cloneId === 'string' ? search.cloneId : undefined,
  }),
});
